import React from 'react';
import PropTypes from 'prop-types';
import { withTracker } from 'meteor/react-meteor-data';
import { ReactiveVar } from 'meteor/reactive-var';
import { isEmpty } from 'lodash';

import OAuthLoginButton from '../OAuthLoginButton';
import Styles from './styles';

import methodPromise from '../../../modules/method-promise-wrapper';

const OAuthLoginButtons = ({ servicesArray, emailMessage }) => {
  if (isEmpty(servicesArray)) return '';
  return (
    <Styles.OAuthLoginButtons emailMessage>
      {servicesArray.map(service => (
        <OAuthLoginButton key={service} service={service} />
      ))}
      {emailMessage && (
        <Styles.EmailMessage offset={emailMessage.offset}>{emailMessage.text}</Styles.EmailMessage>
      )}
    </Styles.OAuthLoginButtons>
  );
};

OAuthLoginButtons.defaultProps = {
  servicesArray: []
};

OAuthLoginButtons.propTypes = {
  servicesArray: PropTypes.array,
  emailMessage: PropTypes.object.isRequired
};

const verificationComplete = new ReactiveVar(false);
const verifiedServices = new ReactiveVar([]);

export default withTracker(({ services }) => {
  if (!verificationComplete.get()) {
    methodPromise('oauth.verifyConfiguration', services)
      .then(response => {
        verifiedServices.set(response);
        verificationComplete.set(true);
      })
      .catch(error => {
        console.warn(error);
      });
  }

  return {
    servicesArray: verifiedServices.get()
  };
})(OAuthLoginButtons);
